import { NavLink } from "react-router-dom";
import { useGetCallsAnalyticsQuery } from "../../../../store/reservations/reservationsApi";

const SaloonCallStatistics = () => {
  const { data } = useGetCallsAnalyticsQuery();
  const stats = data || {
    todayCalls: 0,
    last7DaysCalls: 0,
    lastMonthCalls: 0,
    totalCalls: 0,
  };
  return (
    <div className="w-full my-6">
      <div className="flex flex-wrap border-b text-[#6A6C6A] pb-2">
        Metrics
        <span className="ml-auto font-semibold text-base underline text-black">
          Today
        </span>
      </div>
      <div className="flex flex-wrap mt-5">
        <div className="w-full md:w-8/12">
          <div className="h-32 border-b flex flex-row items-end mb-8 md:mb-0">
            <div className="w-12 mx-10 -mb-5">
              <div
                className="bg-saloon-analytics-100 transition-all h-0"
                title={stats?.todayCalls + ""}
                style={{
                  height: Number(
                    (stats?.todayCalls / stats?.lastMonthCalls) * 100
                  ),
                }}
              />
              <div className="h-5 text-sm font-normal pt-1 text-center">
                Today
              </div>
            </div>
            <div className="w-12 mx-10 -mb-5">
              <div
                className="bg-saloon-analytics-200 transition-all h-0"
                title={stats?.last7DaysCalls + ""}
                style={{
                  height: Number(
                    (stats?.last7DaysCalls / stats?.lastMonthCalls) * 100
                  ),
                }}
              />
              <div className="h-5 text-sm font-normal pt-1 text-center">
                Week
              </div>
            </div>
            <div className="w-12 mx-10 -mb-5">
              <div
                className="bg-saloon-analytics-300 transition-all h-0"
                title={stats?.lastMonthCalls + ""}
                style={{
                  height: Number(
                    (stats?.lastMonthCalls / stats?.lastMonthCalls) * 100
                  ),
                }}
              />
              <div className="h-5 text-sm font-normal pt-1 text-center">
                Month
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-4/12">
          <div className="pl-4 flex flex-wrap">
            <div className="w-6/12 p-2">
              <div className="bg-saloon-analytics-100 rounded-2xl py-2 px-4">
                <h4 className="text-xl font-semibold">{stats?.todayCalls}</h4>
                <p className="text-sm font-normal">Today</p>
              </div>
            </div>
            <div className="w-6/12 px-3 p-2">
              <div className="bg-saloon-analytics-200 rounded-2xl py-2 px-4">
                <h4 className="text-xl font-semibold">
                  {stats?.last7DaysCalls}
                </h4>
                <p className="text-sm font-normal">Last 7 days</p>
              </div>
            </div>
            <div className="w-6/12 px-3 p-2">
              <div className="bg-saloon-analytics-300 rounded-2xl py-2 px-4">
                <h4 className="text-xl font-semibold">
                  {stats?.lastMonthCalls}
                </h4>
                <p className="text-sm font-normal">Last Month</p>
              </div>
            </div>
            <div className="w-6/12 px-3 p-2">
              <div className="bg-saloon-analytics-400 rounded-2xl  py-2 px-4">
                <h4 className="text-xl font-semibold">{stats?.totalCalls}</h4>
                <p className="text-sm font-normal">Total</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col justify-center items-center mt-40 mb-20">
        <NavLink
          to="invoices"
          className="bg-saloon-primary hover:bg-opacity-80 rounded-3xl p-3 text-center text-base w-80"
        >
          Go To Invoices
        </NavLink>
        <NavLink
          to="calls"
          className="bg-[#F1F3F4] hover:bg-opacity-80 rounded-3xl p-3 text-center text-base w-80 my-3"
        >
          Go To Call Details
        </NavLink>
      </div>
    </div>
  );
};

export default SaloonCallStatistics;
